import React, { useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { RootState } from 'store/index';
import { fetchSites } from 'store/sitesSlice';
import { commonSelectSx } from 'styles/muiStyles';

interface SiteSelectorProps {
  value: string | number;
  onChange: (value: string | number) => void;
  minWidth?: number | string;
  showAllOption?: boolean;
}

const SiteSelector: React.FC<SiteSelectorProps> = ({
  value,
  onChange,
  minWidth = 180,
  showAllOption = true,
}) => {
  const dispatch = useAppDispatch();
  const { data: sites, isLoading: sitesLoading } = useAppSelector(
    (state: RootState) => state.sites,
  );

  useEffect(() => {
    if (sites.length === 0) {
      dispatch(fetchSites({ page: 1, limit: 100, sortField: 'createdAt', sortValue: 'DESC' }));
    }
  }, [dispatch, sites.length]);

  const handleChange = (e: SelectChangeEvent<string | number>) => {
    onChange(e.target.value as string | number);
  };

  return (
    <FormControl size="small" sx={{ minWidth }}>
      <InputLabel sx={{ color: '#8698a6' }}>Site</InputLabel>
      <Select
        value={value}
        label="Site"
        onChange={handleChange}
        disabled={sitesLoading}
        sx={commonSelectSx}
      >
        {showAllOption && <MenuItem value="all">All Sites</MenuItem>}
        {sites.map((site) => (
          <MenuItem key={site.id} value={site.id}>
            {site.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SiteSelector;
